import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

export default function AppTabPanes({ comps }) {
  const [value, setValue] = React.useState('1');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%', typography: 'body1' }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"  
            scrollButtons="auto"  
            aria-label="scrollable tabs"
          >
            {comps.map((item, index) => (
              <Tab  sx={{ fontSize: '0.7rem' }} key={item.label} label={item.label} value={String(index + 1)} />
            ))}
          </Tabs>
        </Box>
        {comps.map((item, index) => (
          <TabPanel value={String(index + 1)} key={item.label}>
            {item.component}
          </TabPanel>
        ))}
      </TabContext>
    </Box>
  );
}
